"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Translations = require("react-platform-components/dist/Translations");
var _config = require("../config");
var _reactRedux = require("react-redux");
var _ConfirmationDialog = _interopRequireDefault(require("react-platform-components/dist/ConfirmationDialog"));
var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));
var _SubscriptionPurchaseItem = _interopRequireDefault(require("./components/SubscriptionPurchaseItem"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    header: {
      backgroundColor: "#0a76a9",
      backgroundImage: "url(\"".concat(_config.STATIC_PATH, "/assets/images/backgrounds/header-bg.png\")"),
      backgroundSize: 'cover',
      color: '#fff',
      display: 'flex',
      height: '10vh',
      minHeight: '10vh'
    }
  };
});
function ActiveSubscriptions() {
  var classes = useStyles();
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    deleteOpen = _useState2[0],
    setDeleteOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedSubscription = _useState4[0],
    setSelectedSubscription = _useState4[1];
  var subscriptionPurchases = (0, _reactRedux.useSelector)(function (state) {
    return state.activeSubscriptionsReducer.subscriptionPurchases;
  });
  (0, _react.useEffect)(function () {
    dispatch({
      type: 'FETCH_SUBSCRIPTION_PURCHASES'
    });
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "p-12 pt-80 flex flex-1 flex-col items-center justify-center md:flex-row md:items-end ".concat(classes.header)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-1 flex-col items-center justify-center md:flex-row md:items-center md:justify-start white"
  }, /*#__PURE__*/_react.default.createElement(_CheckCircle.default, {
    className: "md:mr-4"
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: "white",
    variant: "h5"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Mes abonnements",
    defaultMessage: "Mes abonnements"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-center justify-end"
  })), (subscriptionPurchases === null || subscriptionPurchases === void 0 ? void 0 : subscriptionPurchases.length) > 0 && /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: ""
  }, /*#__PURE__*/_react.default.createElement(_core.List, null, subscriptionPurchases.map(function (item) {
    return item.purchase_salable_items.map(function (subscription, index) {
      return /*#__PURE__*/_react.default.createElement(_SubscriptionPurchaseItem.default, {
        item: item,
        subscription: subscription,
        index: index,
        setDeleteOpen: setDeleteOpen,
        setSelectedSubscription: setSelectedSubscription
      });
    });
  }))), deleteOpen && /*#__PURE__*/_react.default.createElement(_ConfirmationDialog.default, {
    closeLabel: "Annuler",
    confirmLabel: "Confirmer",
    title: "\xCAtes-vous s\xFBr de vouloir anuuler ce subscription?",
    open: deleteOpen,
    close: function close() {
      return setDeleteOpen(false);
    },
    confirmAction: function confirmAction() {
      dispatch({
        type: 'UNSUBSCRIBE',
        id: selectedSubscription.purchase_id
      });
      setDeleteOpen(false);
      setSelectedSubscription(null);
    }
  }));
}
var _default = ActiveSubscriptions;
exports.default = _default;